<template>
  <button
    v-if="button"
    v-bind="$attrs"
    type="button"
    class="pb-item"
    @click="emit('click', $event)"
  >
    <PbIcon
      v-if="icon"
      class="pb-item-icon"
      :value="icon"
    />
    <div class="pb-item-name">
      <slot />
    </div>
  </button>
  <div
    v-else
    class="pb-item"
    v-bind="$attrs"
  >
    <PbIcon
      v-if="icon"
      class="pb-item-icon"
      :value="icon"
    />
    <div class="pb-item-name">
      <slot />
    </div>
  </div>
</template>

<script setup>
import PbIcon from '@/components/PbIcon/PbIcon.vue'

defineOptions({
  compatConfig: {
    MODE: 3, // opt-in to Vue 3 behavior for this component only
  },
  inheritAttrs: false,
})

defineProps({
  button: { type: Boolean, default: false },
  icon: { type: [Array, String], default: undefined },
})

const emit = defineEmits(['click'])
</script>

<style lang="scss" src="./PbItem.scss" />
